import { z } from 'zod';
import { optionalNonNegativeNumberString, requiredUuidString } from '../zod-helpers/index.js';
import { PART_CONSTRAINTS } from './constraints.js';
import { checkReorderPointVsOrderUpTo } from './rules.js';
export const partStockSetupRowSchema = z.object({
    locationGroupId: requiredUuidString('Warehouse is required.', 'Invalid warehouse selection.'),
    locationId: requiredUuidString('Location is required.', 'Invalid location selection.'),
    reorderPoint: optionalNonNegativeNumberString(PART_CONSTRAINTS.reorderPoint.label),
    orderUpToLevel: optionalNonNegativeNumberString(PART_CONSTRAINTS.orderUpToLevel.label),
});
export const partStockSetupEditFormSchema = z.object({
    /** Blank means every difference opens a variance; the register is strict until it is tuned. */
    cycleCountTol: optionalNonNegativeNumberString(PART_CONSTRAINTS.cycleCountTol.label).refine((value) => value.trim() === '' || Number(value) <= PART_CONSTRAINTS.cycleCountTol.max, PART_CONSTRAINTS.cycleCountTol.maxMessage),
    locations: z.array(partStockSetupRowSchema).superRefine((locations, context) => {
        const seenLocationGroupIds = new Set();
        locations.forEach((location, index) => {
            if (seenLocationGroupIds.has(location.locationGroupId)) {
                context.addIssue({
                    code: 'custom',
                    message: 'Each warehouse can only appear once.',
                    path: [index, 'locationGroupId'],
                });
            }
            seenLocationGroupIds.add(location.locationGroupId);
            const reorderPoint = location.reorderPoint.trim() === '' ? null : Number(location.reorderPoint);
            const orderUpToLevel = location.orderUpToLevel.trim() === '' ? null : Number(location.orderUpToLevel);
            const message = checkReorderPointVsOrderUpTo(reorderPoint, orderUpToLevel);
            if (message) {
                context.addIssue({ code: 'custom', message, path: [index, 'reorderPoint'] });
            }
        });
    }),
});
//# sourceMappingURL=stock-setup-form.js.map